import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import isMobile from 'ismobilejs';
import { useLocale } from '@devsisters/gatsby-plugin-i18n';

import { asset } from '~/src/assets';
import { scaledCss } from '~/src/css';

interface StoreLinkProps {
  className?: string;
  href: string;
}
const StoreLink: React.FC<StoreLinkProps> = ({ className, href }) => {
  const locale = useLocale();
  const [store, setStore] = useState<null | 'playstore' | 'appstore'>(null);
  useEffect(() => {
    if (isMobile(navigator.userAgent).android.device) {
      setStore('playstore');
    } else {
      setStore('appstore');
    }
  }, []);
  return store ? (
    <Link className={className} href={href} target="_blank">
      <Image src={asset(`${store}/${locale}.svg`)} />
    </Link>
  ) : null;
};

export default StoreLink;

const Link = styled('a')(
  scaledCss({
    margin: '0.8em auto',
  })
);

const Image = styled('img')(
  scaledCss({
    height: [75, '75px'],
  })
);
